import { ethereum } from '@0xtorch/core'
import { unichain } from 'viem/chains'
import { type Client, createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createEtherscanV2 } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createUnichain = ({
  explorerApiKey: apiKey,
  explorerProxyUrl: proxyUrl,
  explorerPageSize: pageSize,
}: {
  explorerApiKey?: string
  explorerProxyUrl?: string
  explorerPageSize?: number
}) =>
  createUnichainCustom({
    client: createClient({
      chain: unichain,
      httpRpcs: unichainHttpRpcs,
    }),
    explorer: createEtherscanV2({
      name: 'Uniscan',
      baseUrl: 'https://uniscan.xyz',
      chainId: 130,
      apiKey,
      proxyUrl,
      pageSize,
    }),
  })

type CreateUnichainParameters = {
  client: Client
  explorer: Explorer
}

export const createUnichainCustom = ({
  client,
  explorer,
}: CreateUnichainParameters): Chain => ({
  id: 130,
  network: 'unichain',
  name: 'Unichain',
  nativeToken: {
    name: 'Ethereum',
    symbol: 'ETH',
    decimals: 18,
    currency: ethereum,
  },
  wrappedTokenAddresses: new Set([
    '0x4200000000000000000000000000000000000006',
  ]),
  explorer,
  client,
  blockTime: 1000,
  coingeckoId: 'unichain',
  defillamaId: undefined,
})

export const unichainHttpRpcs: HttpRpc[] = [
  {
    url: 'https://mainnet.unichain.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://unichain.api.onfinality.io/public',
    getLogsIsUsable: false,
    getLogsMaxBlockRange: 0n,
  },
  {
    url: 'https://unichain-rpc.publicnode.com',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://unichain.drpc.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://unichain-mainnet.rpc.sentio.xyz',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
]

export const unichainWebsocketRpcUrls: readonly string[] = [
  'wss://unichain-rpc.publicnode.com',
  'wss://unichain.drpc.org',
  'wss://0xrpc.io/uni',
]
